// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file branch/create_new_stock_point.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { StockPointType } from "../auth/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreateNewStockPointRequest
 */
export class CreateNewStockPointRequest extends Message<CreateNewStockPointRequest> {
  /**
   * Name of the new stock point
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Name of the manager responsible for the stock point
   *
   * @generated from field: string manager_name = 2;
   */
  managerName = "";

  /**
   * Type of the stock point (e.g., pharmacy, warehouse, etc.)
   *
   * @generated from field: com.neulink.pharmacy.StockPointType stock_point_type = 3;
   */
  stockPointType = StockPointType.UNKNOWN;

  /**
   * Start time of the current shift
   *
   * @generated from field: string shift_start_time = 4;
   */
  shiftStartTime = "";

  /**
   * End time of the current shift
   *
   * @generated from field: string shift_end_time = 5;
   */
  shiftEndTime = "";

  constructor(data?: PartialMessage<CreateNewStockPointRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNewStockPointRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "manager_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stock_point_type", kind: "enum", T: proto3.getEnumType(StockPointType) },
    { no: 4, name: "shift_start_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shift_end_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNewStockPointRequest {
    return new CreateNewStockPointRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNewStockPointRequest {
    return new CreateNewStockPointRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNewStockPointRequest {
    return new CreateNewStockPointRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNewStockPointRequest | PlainMessage<CreateNewStockPointRequest> | undefined, b: CreateNewStockPointRequest | PlainMessage<CreateNewStockPointRequest> | undefined): boolean {
    return proto3.util.equals(CreateNewStockPointRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateNewStockPointResponse
 */
export class CreateNewStockPointResponse extends Message<CreateNewStockPointResponse> {
  constructor(data?: PartialMessage<CreateNewStockPointResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateNewStockPointResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNewStockPointResponse {
    return new CreateNewStockPointResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNewStockPointResponse {
    return new CreateNewStockPointResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNewStockPointResponse {
    return new CreateNewStockPointResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNewStockPointResponse | PlainMessage<CreateNewStockPointResponse> | undefined, b: CreateNewStockPointResponse | PlainMessage<CreateNewStockPointResponse> | undefined): boolean {
    return proto3.util.equals(CreateNewStockPointResponse, a, b);
  }
}

